import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

export interface ModalAction {
    label: string;
    callback: () => void;
    active: boolean;
}

export interface ModalProps {
    title: string;
    actions: ModalAction[];
    show: boolean;
    children: any;
    handleClose: () => void;
}

export function ReusableModal({ title, actions, children, handleClose, show = false }: ModalProps) {
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>{children}</Modal.Body>

            <Modal.Footer>
                {actions.map((action, idx) => {
                    return (
                        <Button key={idx} disabled={!action.active} onClick={action.callback}>
                            {action.label}
                        </Button>
                    );
                })}
            </Modal.Footer>
        </Modal>
    );
}
